export default "__VITE_ASSET__BvgO2f_B__"